.svg{height:35rem}
/*# sourceMappingURL=timer.component-4ND3FE5V.css.map */
